/* AEVORA motion — révèle TOUS les éléments ciblés (jamais un sous-ensemble),
   révèle immédiatement ce qui est déjà à l'écran, fallback tout-visible. */
(function () {
  var d = document;
  d.documentElement.classList.add('av-js');

  function init() {
    var sel = '.avh-card,.avh-cat,.avh-gar,.avh-hero-content,.avh-split-media,.avh-split-body,.avh-story,.avm-item,.aevora-rev-card,.aevora-why-card,.aevora-feature-card,.aevora-faq-row,.aevora-also-card,.aevora-hero-main,.aevora-buybox,.aevora-detail-media,.aevora-detail-body,.aevora-usp-media,.aevora-usp-body,.aevora-addon,.aevora-searchband-form';
    var vh = window.innerHeight;
    var els = [].slice.call(d.querySelectorAll(sel)).filter(function (el) {
      var r = el.getBoundingClientRect();
      return !(r.top < vh && r.bottom > 0);
    });
    var counts = [];
    els.forEach(function (el) {
      el.classList.add('av-reveal');
      var p = el.parentElement, n = 0, found = false;
      for (var i = 0; i < counts.length; i++) { if (counts[i].p === p) { n = ++counts[i].n; found = true; break; } }
      if (!found) counts.push({ p: p, n: 0 });
      el.style.setProperty('--avd', Math.min(n * 80, 400) + 'ms');
    });

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('av-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('av-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      els.forEach(function (el) { io.observe(el); });
    }

    var vids = [].slice.call(d.querySelectorAll('video[data-av-autoplay],video[autoplay]'));
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }); }
    if ('IntersectionObserver' in window && vids.length) {
      var vio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else { v.pause(); }
        });
      }, { threshold: 0.2 });
      vids.forEach(function (v) { vio.observe(v); });
    }
  }

  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

/* Carrousels : fleches + defilement automatique (pause au survol/toucher, stoppe hors ecran, reduced-motion respecte) */
(function () {
  var d = document;
  function initCar() {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    [].slice.call(d.querySelectorAll('.av-car-wrap')).forEach(function (wrap) {
      var track = wrap.querySelector('.av-carousel');
      if (!track || track.children.length < 2) return;
      var prev = wrap.querySelector('.av-prev'), next = wrap.querySelector('.av-next');
      function step() {
        var c = track.children[0];
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 16;
        return c.getBoundingClientRect().width + gap;
      }
      function maxLeft() { return track.scrollWidth - track.clientWidth - 2; }
      function go(dir) {
        var target = track.scrollLeft + dir * step();
        if (dir > 0 && track.scrollLeft >= maxLeft()) target = 0;
        track.scrollTo({ left: target, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      if (reduced) return;
      var visible = false, paused = false, timer = null;
      function tick() { if (visible && !paused) go(1); }
      function arm() { if (!timer) timer = setInterval(tick, 4000); }
      ['pointerenter', 'touchstart', 'focusin'].forEach(function (ev) { track.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      ['pointerleave', 'touchend', 'focusout'].forEach(function (ev) { track.addEventListener(ev, function () { paused = false; }, { passive: true }); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { es.forEach(function (e) { visible = e.isIntersecting; }); arm(); }, { threshold: 0.3 }).observe(wrap);
      } else { visible = true; arm(); }
    });
  }
  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', initCar); } else { initCar(); }
})();

/* Barre d'achat collante mobile : apparait quand le vrai CTA sort de l'ecran, soumet le VRAI formulaire */
(function () {
  var d = document;
  function initSticky() {
    var form = d.querySelector('.aevora-atc-form');
    var cta = d.querySelector('.aevora-buybox .aevora-cta');
    if (!form || !cta) return;
    var titleEl = d.querySelector('.aevora-buybox .aevora-h1') || d.querySelector('h1');
    var priceEl = d.querySelector('.aevora-buybox .aevora-price');
    var bar = d.createElement('div');
    bar.className = 'av-stickybar';
    bar.innerHTML = '<div class="av-stickybar-meta"><span class="av-stickybar-title"></span><span class="av-stickybar-price"></span></div><button type="button" class="av-stickybar-btn">Ajouter au panier</button>';
    d.body.appendChild(bar);
    function sync() {
      bar.querySelector('.av-stickybar-title').textContent = titleEl ? titleEl.textContent.trim() : '';
      bar.querySelector('.av-stickybar-price').textContent = priceEl ? priceEl.textContent.trim() : '';
    }
    sync();
    d.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.aevora-bundle')) setTimeout(sync, 50); });
    bar.querySelector('.av-stickybar-btn').addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle('av-on', passed);
        });
      }, { threshold: 0 }).observe(cta);
    } else { bar.classList.add('av-on'); }
  }
  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', initSticky); } else { initSticky(); }
})();
